import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import EducationItem from './EducationItem';
import { moveElementPosition } from '../../../../utils/splices';

import { EDUCATION } from '../../../../constants/literals/modals';

/**
 * Import styles
 */
import {
  StyledBoxDown,
  StyledButton,
  StyledButtonPlus,
  StyledLabelError
} from './style';

import { StyleModalNew } from './styleEducation';

// import { postSugerency } from '../../../../utils/apiDataUserForm';

class Education extends Component {
  constructor(props) {
    super(props);

    const data = props.dataEducation.map(item => ({
      ...item
    }));

    this.state = {
      data,
      dataEducationFormatted: data,
      btnIsDisabled: true,
      controlError: false
    };
  }

  componentDidMount() {
    const { data } = this.state;

    if (data.length === 0) {
      this.handlePlus();
    }
  }

  onClickExpand(index) {
    const { data } = this.state;
    const clonedData = [...data];

    clonedData[index] = {
      ...clonedData[index],
      expanded: !clonedData[index].expanded
    };

    this.setState({ data: clonedData });
  }

  onClickDelete = index => {
    const { data } = this.state;
    const updatedData = data.filter((ele, i) => i !== index);

    this.setState({
      data: updatedData,
      btnIsDisabled: this.getBtnStatus(updatedData)
    });
  };

  onClickOrderArrow = (index, isDown) => {
    const { data } = this.state;
    const move = isDown ? index + 1 : index - 1;
    const updatedData = moveElementPosition([...data], index, move);

    this.setState({
      data: updatedData,
      btnIsDisabled: this.getBtnStatus(updatedData)
    });
  };

  onChangeDropdownMonthInput = (index, key, event) => {
    const { data } = this.state;
    const clonedData = [...data];
    const monthIndex = event.value;
    const date = clonedData[index][key]
      ? `${clonedData[index][key].split('-')[0]}-${monthIndex}`
      : `-${monthIndex}`;

    clonedData[index] = { ...clonedData[index], [key]: date };

    this.setState({
      data: clonedData,
      btnIsDisabled: this.getBtnStatus(clonedData)
    });
  };

  onChangeDropdownYearInput = (index, key, event) => {
    const { data } = this.state;
    const clonedData = [...data];
    const yearIndex = event.value;
    const date = clonedData[index][key]
      ? `${yearIndex}-${clonedData[index][key].split('-')[1]}`
      : `${yearIndex}-`;

    clonedData[index] = { ...clonedData[index], [key]: date };

    this.setState({
      data: clonedData,
      btnIsDisabled: this.getBtnStatus(clonedData)
    });
  };

  getBtnStatus = data => {
    const { dataEducationFormatted } = this.state;

    return _.isEqual(dataEducationFormatted, data);
  };

  getLabelMonth(date) {
    const { listMonths } = this.props;
    const month = date.split('-')[1];
    const label =
      listMonths.find(objMonth => objMonth.value === month) &&
      listMonths.find(objMonth => objMonth.value === month).text;

    return label || 'Febrero';
  }

  getLabelYear(date) {
    const { listYears } = this.props;
    const year = date.split('-')[0];
    const label = listYears.find(objYear => objYear.value === year)
      ? listYears.find(objYear => objYear.value === year).text
      : year;

    return label;
  }

  handleAccept = () => {
    const { onAcceptModal } = this.props;
    const { data } = this.state;
    const error = this.validateFields();
    if (error) {
      this.setState({
        data: data.map(item => ({
          ...item
        })),
        controlError: true
      });
    } else {
      for (const ele in data) {
        if (data[ele].categoryId1 === 0) {
          // postSugerency('EDUCATION_CATEGORY1', data[ele].schoolName);
        }
      }
      this.setState({
        controlError: false
      });
      onAcceptModal(data);
    }
  };

  handleChange = (value, index, key) => {
    const { data } = this.state;
    const clonedData = [...data];
    clonedData[index] = { ...clonedData[index], [key]: value };
    this.setState({
      data: clonedData,
      btnIsDisabled: this.getBtnStatus(clonedData)
    });
  };

  handlePlus = () => {
    const { data } = this.state;
    const { selectedMonths, selectedYears } = this.props;
    const clonedData = [...data];

    clonedData.push({
      degree: '',
      schoolName: '',
      startDate: `${selectedYears}-${selectedMonths}`,
      endDate: `${selectedYears}-${selectedMonths}`
    });
    this.setState({
      data: clonedData,
      btnIsDisabled: this.getBtnStatus(clonedData)
    });
  };

  validateFields() {
    const { data } = this.state;
    const { formUser } = this.props;
    if (!formUser) {
      for (const ele in data) {
        if (
          !data[ele].degree ||
          !data[ele].schoolName ||
          !data[ele].certificateName
        ) {
          return true;
        }
      }
    } else {
      for (const ele in data) {
        if (
          !data[ele].degree ||
          !data[ele].schoolName ||
          !data[ele].certificateName ||
          !data[ele].categoryId1 === null
        ) {
          return true;
        }
      }
    }
    return false;
  }

  render() {
    const {
      listMonths,
      listYears,
      onCloseModal,
      selectedMonths,
      selectedYears,
      formUser
    } = this.props;
    const { data, btnIsDisabled, controlError } = this.state;
    return (
      <StyleModalNew
        title={EDUCATION.TITLE}
        clickCloseIcon={onCloseModal}
        tabletSize
      >
        {data.map((item, index) => {
          const labelSelectedStartMonth = item.startDate
            ? this.getLabelMonth(item.startDate)
            : selectedMonths;
          const labelSelectedEndMonth = item.endDate
            ? this.getLabelMonth(item.endDate)
            : selectedMonths;
          const labelSelectedStartYear = item.startDate
            ? this.getLabelYear(item.startDate)
            : selectedYears;
          const labelSelectedEndYear = item.endDate
            ? this.getLabelYear(item.endDate)
            : selectedYears;

          return (
            <EducationItem
              formUser={formUser}
              key={`${item.startDate}${index + 1}`}
              expanded={item.expanded}
              order={index + 1}
              degree={item.degree}
              certificateName={item.certificateName}
              categoryId1={item.categoryId1}
              categoryId2={item.categoryId2}
              categoryId3={item.categoryId3}
              school={item.schoolName}
              listMonths={listMonths}
              listYears={listYears}
              onChangeDegreeInput={e => this.handleChange(e, index, 'degree')}
              onChangeCategory1={e => {
                this.handleChange(e.id, index, 'categoryId1');
                this.handleChange(e.name, index, 'degree');
              }}
              onChangeCategory2={e => {
                this.handleChange(e.id, index, 'categoryId2');
                this.handleChange(e.name, index, 'degree');
              }}
              onChangeCategory3={e => {
                this.handleChange(e.id, index, 'categoryId3');
                this.handleChange(e.name, index, 'degree');
              }}
              onChangeSchoolInput={e => {
                this.handleChange(e, index, 'schoolName');
              }}
              onChangeCertificateInput={e => {
                this.handleChange(e, index, 'certificateName');
              }}
              onClickExpand={() => this.onClickExpand(index)}
              onClickDelete={() => this.onClickDelete(index)}
              onClickDown={() => this.onClickOrderArrow(index, true)}
              onClickUp={() => this.onClickOrderArrow(index, false)}
              labelStartMonth={labelSelectedStartMonth}
              labelEndMonth={labelSelectedEndMonth}
              labelStartYear={labelSelectedStartYear}
              labelEndYear={labelSelectedEndYear}
              selectedStartMonth={labelSelectedStartMonth}
              selectedEndMonth={labelSelectedEndMonth}
              selectedStartYear={labelSelectedStartYear}
              selectedEndYear={labelSelectedEndYear}
              onSelectStartMonth={e =>
                this.onChangeDropdownMonthInput(index, 'startDate', e)
              }
              onSelectStartYear={e =>
                this.onChangeDropdownYearInput(index, 'startDate', e)
              }
              onSelectEndMonth={e =>
                this.onChangeDropdownMonthInput(index, 'endDate', e)
              }
              onSelectEndYear={e =>
                this.onChangeDropdownYearInput(index, 'endDate', e)
              }
              errorTitle={item.errorDegree}
              errorCenter={item.errorSchoolName}
              controlError={controlError}
            />
          );
        })}
        <StyledButtonPlus dark onClick={this.handlePlus} tabletSize />

        {controlError && (
          <StyledLabelError>*Faltan campos por rellenar</StyledLabelError>
        )}
        <StyledBoxDown>
          <StyledButton onClick={onCloseModal} modal>
            {EDUCATION.CANCEL}
          </StyledButton>
          <StyledButton
            onClick={this.handleAccept}
            secondary
            disabled={btnIsDisabled}
          >
            {EDUCATION.ACCEPT}
          </StyledButton>
        </StyledBoxDown>
      </StyleModalNew>
    );
  }
}

Education.propTypes = {
  dataEducation: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
      fromMonth: PropTypes.string,
      fromYear: PropTypes.string,
      untilMonth: PropTypes.string,
      untilYear: PropTypes.string,
      active: PropTypes.bool
    })
  ),
  listMonths: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      value: PropTypes.oneOfType[(PropTypes.string, PropTypes.number)],
      id: PropTypes.oneOfType[(PropTypes.string, PropTypes.number)]
    })
  ).isRequired,
  listYears: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      value: PropTypes.oneOfType[(PropTypes.string, PropTypes.number)],
      id: PropTypes.oneOfType[(PropTypes.string, PropTypes.number)]
    })
  ).isRequired,
  onAcceptModal: PropTypes.func,
  onCloseModal: PropTypes.func,
  selectedMonths: PropTypes.string,
  selectedYears: PropTypes.string,
  formUser: PropTypes.bool
};

Education.defaultProps = {
  dataEducation: [],
  selectedMonths: '01',
  selectedYears: '2018',
  formUser: false
};

export default Education;
